import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'
import { v2EmployeeKeys } from './use-v2-employee-find-query'

type UpdateEmployeeBody = Parameters<typeof apiClient.v2.apiV2EmployeeElUpdate>[0]

const updateEmployee = async (body: UpdateEmployeeBody) => {
  const { data } = await apiClient.v2.apiV2EmployeeElUpdate(body)
  return checkApiResponse(data)
}

export const useV2EmployeeUpdateMutation = ({ options }: MutationComposableParams<unknown, UpdateEmployeeBody> = {}) => {
  const queryClient = useQueryClient()
  return useMutation(() => {
    const resolved = resolveMaybeGetter(options ?? {})
    return {
      mutationFn: updateEmployee,
      ...resolved,
      // 저장 성공 시 도메인 캐시를 무효화한다 — 다음 조회가 fresh 데이터를 가져온다
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: v2EmployeeKeys.all })
        return (resolved as { onSuccess?: (...args: unknown[]) => unknown }).onSuccess?.(data, variables, context)
      },
    }
  })
}
